export default function HighlightedTitle({ title, highlight }: { title: string; highlight: string }) {
  const index = highlight ? title.indexOf(highlight) : -1;
  if (index === -1) return <>{title}</>;
  return (
    <>
      {title.slice(0, index)}
      <span className="[box-shadow:inset_0_-0.2em_0_var(--brand-accent)]">{highlight}</span>
      {title.slice(index + highlight.length)}
    </>
  );
}
